import { usePermissions } from '@/layouts/PermissionsContext';
import { defaultFinancePath } from '@/layouts/permissions';
import { Result } from 'antd';
import { Navigate } from 'react-router-dom';

/**
 * `/` 的落点：能填报就进「我的报销单」，否则进「财务总览」。
 * 两个都没权限时由 FinanceLayout 统一出 403，这里不会被渲染到。
 */
export default function FinanceHome() {
  const { grant, loading } = usePermissions();
  if (loading) return null;
  const landing = defaultFinancePath(grant);
  if (!landing) {
    return <Result status="403" title="403" subTitle="当前账号没有财务系统权限" />;
  }
  return <Navigate to={landing} replace />;
}
